export default "__VITE_ASSET__D379f0wS__"